export const USER_TYPES = {
  BKASH_SUPER_USER: "bkash-super-user",
  CIRCLE_HEAD: "cluster_head",
  REGIONAL_MANAGER: "regional_manager",
  AREA_MANAGER: "area_manager",
  TERRITORY_MANAGER: "territory_manager",
  AGENCY_USER: "agency_user",
  CS_SUPER_USER: "cs_super_user",
  CS_USER_LAYER_1: "cs_user_layer_1",
  CS_USER_LAYER_2: "cs_user_layer_2",
  WAREHOUSE_MANAGER: "warehouse_manager",
};

export const APP_SCOPE_ONLINE = "online";
export const APP_SCOPE_MERCHANT_BUSINESS = "merchant_business";

export const MANAGER_TYPES = {
  MDE: "MDE",
  MDM: "MDM",
  MAM: "MAM",
  MMM: "MMM",
  DISTRIBUTOR: "dh_user",
  OPERATION_MANAGER: "operation_manager",
  DISTRIBUTION_CREDIT_MANAGER: "credit_manager",
};

export const USER_ROLES = [
  {
    id: 1,
    key: USER_TYPES.BKASH_SUPER_USER,
    name: "Super User",
    value: USER_TYPES.BKASH_SUPER_USER,
  },
  {
    id: 2,
    key: USER_TYPES.CIRCLE_HEAD,
    name: "Circle Head",
    value: USER_TYPES.CIRCLE_HEAD,
  },
  {
    id: 3,
    key: USER_TYPES.REGIONAL_MANAGER,
    name: "Zone Manager",
    value: USER_TYPES.REGIONAL_MANAGER,
  },
  {
    id: 4,
    key: USER_TYPES.AREA_MANAGER,
    name: "Area Manager",
    value: USER_TYPES.AREA_MANAGER,
  },
  {
    id: 5,
    key: USER_TYPES.TERRITORY_MANAGER,
    name: "Territory Manager",
    value: USER_TYPES.TERRITORY_MANAGER,
  },
  {
    id: 6,
    key: USER_TYPES.AGENCY_USER,
    name: "Operations Manager",
    value: USER_TYPES.AGENCY_USER,
  },
  {
    id: 7,
    key: USER_TYPES.CS_SUPER_USER,
    name: "CS Super User",
    value: USER_TYPES.CS_SUPER_USER,
  },
  {
    id: 8,
    key: USER_TYPES.CS_USER_LAYER_1,
    name: "CS User Layer 1",
    value: USER_TYPES.CS_USER_LAYER_1,
  },
  {
    id: 9,
    key: USER_TYPES.CS_USER_LAYER_2,
    name: "CS User Layer 2",
    value: USER_TYPES.CS_USER_LAYER_2,
  },
];

export const USER_STATUS_LIST = [
  { id: 1, title: "All", value: "" },
  { id: 2, title: "Active", value: "active" },
  { id: 3, title: "Deactivated", value: "deactivated" },
];

export const FIELD_FORCE_STATUS_ACTIVATED = "Activated";
export const FIELD_FORCE_STATUS_DEACTIVATED = "Deactivated";
export const FIELD_FORCE_STATUS_BLACKLISTED = "Blacklisted";

export const ROLE_FILTER_CONFIG = {
  [USER_TYPES.BKASH_SUPER_USER]: {
    defaultRole: USER_TYPES.CIRCLE_HEAD,
    visibleRoles: [
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.AGENCY_USER,
      USER_TYPES.CS_SUPER_USER,
      USER_TYPES.CS_USER_LAYER_1,
      USER_TYPES.CS_USER_LAYER_2,
    ],
  },
  [USER_TYPES.CIRCLE_HEAD]: {
    defaultRole: USER_TYPES.REGIONAL_MANAGER,
    visibleRoles: [
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.AGENCY_USER,
    ],
  },
  [USER_TYPES.REGIONAL_MANAGER]: {
    defaultRole: USER_TYPES.AREA_MANAGER,
    visibleRoles: [
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.AGENCY_USER,
    ],
  },
  [USER_TYPES.AREA_MANAGER]: {
    defaultRole: USER_TYPES.TERRITORY_MANAGER,
    visibleRoles: [USER_TYPES.TERRITORY_MANAGER, USER_TYPES.AGENCY_USER],
  },
  [USER_TYPES.TERRITORY_MANAGER]: {
    defaultRole: USER_TYPES.AGENCY_USER,
    visibleRoles: [USER_TYPES.AGENCY_USER],
  },
  [USER_TYPES.AGENCY_USER]: {
    defaultRole: "",
    visibleRoles: [],
  },
  [USER_TYPES.CS_SUPER_USER]: {
    defaultRole: USER_TYPES.CS_USER_LAYER_1,
    visibleRoles: [USER_TYPES.CS_USER_LAYER_1, USER_TYPES.CS_USER_LAYER_2],
  },
  [USER_TYPES.CS_USER_LAYER_1]: {
    defaultRole: "",
    visibleRoles: [""],
  },
  [USER_TYPES.CS_USER_LAYER_2]: {
    defaultRole: "",
    visibleRoles: [],
  },
};

export const CS_USERS = [
  USER_TYPES.CS_SUPER_USER,
  USER_TYPES.CS_USER_LAYER_1,
  USER_TYPES.CS_USER_LAYER_2,
];

export const MANAGER_TYPE_OPTIONS = {
  [USER_TYPES.TERRITORY_MANAGER]: [
    { label: "Select Manager Type", value: "", isPlaceholder: true },
    { label: "MDE", value: MANAGER_TYPES.MDE },
    { label: "MDM", value: MANAGER_TYPES.MDM },
    { label: "MAM", value: MANAGER_TYPES.MAM },
    { label: "MMM", value: MANAGER_TYPES.MMM },
  ],
  [USER_TYPES.AGENCY_USER]: [
    { label: "Select Manager Type", value: "", isPlaceholder: true },
    { label: "Distributor", value: MANAGER_TYPES.DISTRIBUTOR },
    { label: "Operation Manager (OM)", value: MANAGER_TYPES.OPERATION_MANAGER },
    {
      label: "Distribution Credit Manager (DCM)",
      value: MANAGER_TYPES.DISTRIBUTION_CREDIT_MANAGER,
    },
  ],
};

export const SUPPORT_LEVEL_OPTIONS = [
  { label: "Select Support Level", value: "", isPlaceholder: true },
  { label: "CS Super User", value: USER_TYPES.CS_SUPER_USER },
  { label: "CS User Layer 1", value: USER_TYPES.CS_USER_LAYER_1 },
  { label: "CS User Layer 2", value: USER_TYPES.CS_USER_LAYER_2 },
];

export const VERIFICATION_TYPE_OPTIONS = [
  { label: "Select Verification Type", value: "", isPlaceholder: true },
  { label: "NID", value: "nid" },
  { label: "Passport", value: "passport" },
  { label: "Driver's License", value: "drivers_license" },
  { label: "Birth Certificate", value: "birth_certificate" },
];

export const LEAVE_DAYS_OPTIONS = [
  { label: "Select Leave Day", value: "", isPlaceholder: true },
  { label: "Sunday", value: "sunday" },
  { label: "Monday", value: "monday" },
  { label: "Tuesday", value: "tuesday" },
  { label: "Wednesday", value: "wednesday" },
  { label: "Thursday", value: "thursday" },
  { label: "Friday", value: "friday" },
  { label: "Saturday", value: "saturday" },
];

export const INITIAL_FORM_STATE = {
  name: "",
  employee_id: "",
  username: "",
  email: "",
  contact_number: "+88",
  user_type: "",
  cluster: [],
  region: [],
  area: [],
  territory: [],
  agency: [],
  joining_date: new Date().toISOString().split("T")[0],
  password: "",
  confirm_password: "",
  image: null,
  user_category: "",
  support_level: "",
  leave_day: "",
  personal_number: "+88",
  father_name: "",
  mother_name: "",
  verification_type: "",
  verification_id: "",
};
